import languages from 'marketplace-front-core/middleware/languages'

export default languages
